import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    VIDEO_LIST: 'لیست ویدیوها',
    TOTAL_VIDEOS: "تعداد از کل",
    VIEW: "بازدید",
    LOADING: "درحال بارگذاری ...",
    SHARE: "اشتراک گذاری",
    WITH: "با",
    DOWNLOAD: "دریافت ویدیو",
    COPIED: "کپی شد",
    PUBLISH_DATE: "تاریخ ایجاد",
    RELATED_ITEMS: "کنفرانس‌ها و همایش پیشنهادی",
    SEE_MORE: "مشاهده بیشتر",
    VIEW_COUNT: 'تعداد بازدیدها',
    EMPTY_LIST: 'ویدیویی یافت نشد',
    PLAY_IN_ORDER: 'پخش به ترتیب',
    PALY_IN_REPEAT: 'تکرار پخش',
    COUNT_OF_TOTAL: 'تعداد از کل',
    OF: 'از',
    LINK_COPY: 'یا کپی لینک'
  },
  [LOCALES.EN]: {
    VIDEO_LIST: 'Video list',
    TOTAL_VIDEOS: "Total videos",
    VIEW: "Views",
    LOADING: "Loading ...",
    SHARE: "Share",
    WITH: "with",
    DOWNLOAD: "Download video",
    COPIED: "Copied",
    PUBLISH_DATE: "Publish Date",
    RELATED_ITEMS: "Suggested for you",
    SEE_MORE: "See More",
    VIEW_COUNT: 'View Count',
    EMPTY_LIST: 'No video is founded',
    PLAY_IN_ORDER: 'Play in order',
    PALY_IN_REPEAT: 'Play in repeat',
    COUNT_OF_TOTAL: 'Total videos',
    OF: 'of',
    LINK_COPY: 'Or copying link'
  },
};

export enum PLAYING_MODE {
  ORDERED,
  REPEATED,
}

export default translation;
